import { render, staticRenderFns } from "./GroupCategory.vue?vue&type=template&id=76320cda"
import script from "./GroupCategory.vue?vue&type=script&lang=js"
export * from "./GroupCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports